import React from 'react'

function WelcomerCategoryIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="160" height="80" viewBox="0 0 160 80" {...props}>
      <defs>
        <clipPath id="WelcomerCategoryIcon">
          <path
            fill="none"
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H160V80H0z"
            data-name="Rectangle 9616"
            transform="translate(12610 -2646)"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="Mask Group 651" transform="translate(-12610 2646)">
        <g transform="translate(12615 -2570.909)">
          <path fill="#263238" d="M140 .5H0v-1h140z" data-name="Line 1582" transform="translate(5 .5)"></path>
        </g>
        <g data-name="Group 57768" transform="translate(-1079.152 -95.353)">
          <g fill="#263238" data-name="Path 76623">
            <path
              d="M55.242 12.151H9.173c-2.374 0-4.461-.787-5.877-2.216A6.16 6.16 0 011.5 5.51v-7.15c0-1.038 1.109-1.883 2.472-1.883h.026l.027-.002 28.12-2.972L60.39-3.525l.026.002h.026c1.363 0 2.472.845 2.472 1.882v7.146c.005 1.912-.569 3.46-1.706 4.6-1.336 1.339-3.399 2.046-5.967 2.046z"
              transform="translate(13736.822 -2493.663)"
            ></path>
            <path
              d="M32.145-5.994L4.025-3.022h-.053C2.903-3.022 2-2.39 2-1.641v7.156a5.664 5.664 0 001.65 4.068c1.322 1.334 3.284 2.068 5.523 2.068h46.069c2.432 0 4.373-.656 5.613-1.9 1.04-1.042 1.565-2.47 1.56-4.246V-1.64c0-.749-.903-1.381-1.972-1.381h-.053L32.145-5.994m0-1.006l28.298 2.978c1.641 0 2.972 1.066 2.972 2.381v7.146c.012 4.62-3.249 7.146-8.173 7.146H9.173C4.25 12.651.963 9.454 1 5.505V-1.64c0-1.315 1.33-2.381 2.972-2.381L32.145-7z"
              transform="translate(13736.822 -2493.663)"
            ></path>
          </g>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M13785.315-2495.702v.119h-32.426l16.213 6.586 16.213-6.586v15.947h-33.006v-16.066z"
            data-name="Path 76624"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeWidth="1"
            d="M13800.645-2526.002s-16.288-1.092-32.035-1.092-30.952 1.092-30.952 1.092v-17.345s15.205.912 30.952.912 32.035-.912 32.035-.912z"
            data-name="Path 76625"
          ></path>
          <g
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            data-name="Group 57767"
            transform="translate(13753.081 -2543.881)"
          >
            <path d="M0 0H3.835V14.077H0z" data-name="Rectangle 9612"></path>
            <path d="M0 0H3.835V14.077H0z" data-name="Rectangle 9613" transform="translate(28.305)"></path>
          </g>
          <path
            fill="#ecf0f1"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M13740.745-2523.332l3.81-.649s.925-.216 1.118.647c0 0 3.322 19.952 3.588 29.087l-1.987 7.023c-4.722-5.645-7.513-34.727-7.513-34.727a1.19 1.19 0 01.984-1.381z"
            data-name="Path 76626"
          ></path>
          <path
            fill="#ecf0f1"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth="1"
            d="M13797.63-2523.332l-3.81-.647s-.925-.216-1.117.646c0 0-3.315 19.949-3.579 29.082l1.99 7.02c4.718-5.645 7.5-34.72 7.5-34.72a1.189 1.189 0 00-.985-1.381z"
            data-name="Path 76627"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M13789.709-2530.86s6.687 18.972 6.687 31.654 0 24.15-8.107 24.15h-38.251c-8.129 0-8.129-11.468-8.129-24.15s6.687-31.654 6.687-31.654z"
            data-name="Path 76628"
          ></path>
          <path
            fill="#ecf0f1"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M13752.94-2497.662v16.871h32.426v-16.871z"
            data-name="Path 76629"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M13760.319-2511.804v18.072h-.074l-2.5 2.5-2.489-2.5h-.074v-16.259l-.007.009v-1.822z"
            data-name="Path 76630"
          ></path>
          <path
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M13783.408-2511.804v18.072h-.074l-2.5 2.5-2.489-2.5h-.074v-16.259l-.007.009v-1.822z"
            data-name="Path 76631"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M0 0H7.676V3.063H0z"
            data-name="Rectangle 9614"
            transform="translate(13753.905 -2504.49)"
          ></path>
          <path
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M0 0H7.676V3.063H0z"
            data-name="Rectangle 9615"
            transform="translate(13776.997 -2504.49)"
          ></path>
          <path
            fill="#ecf0f1"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M13748.601-2531.308a121.862 121.862 0 0120.323-1.607 135.975 135.975 0 0120.83 1.565s2.194 13.547-3.015 19.294-30.091 5.741-35.168 0-2.97-19.252-2.97-19.252z"
            data-name="Path 76632"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default WelcomerCategoryIcon
